
  <div class="search-item">
    <div class="icon-search" (click)="searchEnter()"><ion-icon name="search"></ion-icon></div>
    <input
      [ngClass]="!inputEnFoco ? 'max-with' : 'min-with'"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      type="text"
      placeholder="Buscar"
      (keyup.enter)="searchEnter()"
      [(ngModel)]="search"
    />
  
    <div class="container-information">
      <div *ngIf="inputEnFoco" class="tex-indication">
        Pulse intro para buscar
      </div>
      <ion-icon
        (click)="limpiarInput()"
        *ngIf="search"
        class="icon-clean"
        name="close-outline"
      ></ion-icon>
    </div>
  </div>
  
